import storeInfo from '../store'

export const getPDFUrl = () => storeInfo.store.getState().files.pdfUrl

